<script>
import featureMixin from "@/mixins/featureMixin";
import ClickOutside from "vue-click-outside";
import {mapGetters, mapState} from "vuex";
import PdpRaddar from "@/features/pdp/templates/PdpRaddar.vue";
import {
	PDP_EVENT_HIDE,
	PDP_EVENT_SHOW,
	PDP_MODE_EXTERNAL,
	PDP_MODE_INTERNAL
} from "@/features/pdp/PDP_Constants";
import PdpDefault from "@/features/pdp/templates/PdpDefault.vue";
import PdpDefaultV1 from "@/features/pdp/templates/PdpDefaultV1.vue";
import PdpV2 from "@/features/pdp/templates/PdpV2.vue";
import PdpV3 from "@/features/pdp/templates/PDPV3.vue";
import PdpFrOnly from "@/features/pdp/templates/PdpFrOnly.vue";

//import ParentComms from "@/classes/ParentComms";
//import ObjPropParser from "@/classes/ObjPropParser";
import RaddarPDPOld from "@/features/pdp/templates/RaddarPDPOld.vue";
import {getProductSku} from "@/features/shopping-list/classes/ShoppingListController";
import pdpRexallRaddar from "@/features/pdp/templates/PdpRexallRaddar.vue";
import pdpJeanCoutuRaddar from "@/features/pdp/templates/pdpJeanCoutuRaddar.vue";
import {PRODUCT_REGION_CLICK, PRODUCT_REGION_CLICK_EXTERNAL_LINK, PRODUCT_REGION_CLICK_VALID, PRODUCT_REGION_CLICK_WITH_SKU} from "@/components/block/BlockEvents";
import Lytics from "../../classes/Lytics";
import PdpDefaultV3 from "@/features/pdp/templates/PdpDefaultV3.vue";

export default {
	name: "PDP",
	directives: {
		ClickOutside
	},
	mixins: [featureMixin],
	data() {
		return {
			featurePath: "pdp",
			featureEvents: [
				PRODUCT_REGION_CLICK,
				PRODUCT_REGION_CLICK_WITH_SKU,
				PRODUCT_REGION_CLICK_EXTERNAL_LINK,
				PRODUCT_REGION_CLICK_VALID,
				PDP_EVENT_SHOW,
				PDP_EVENT_HIDE
			],
			product: null
		};
	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside);
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleClickOutside);
	},
	computed: {
		...mapState(['currentPageNumber']),
		...mapGetters("screen", ["flyerOrientation"]),
		...mapGetters("landingPage", ["currentFlyer"]),
		templates() {
			return {
				oldpdp: RaddarPDPOld,
				raddar: PdpRaddar,
				"jc-raddar": pdpJeanCoutuRaddar,
				"rexall-raddar": pdpRexallRaddar,
				v1: PdpDefaultV1,
				v2: PdpV2,
				v3: PdpV3,
				v4: PdpFrOnly,
				default3: PdpDefaultV3,
				default: PdpDefault
			};
		},
		pdpTemplate() {
			//return RaddarPDPOld;
			const t = this.templates;
			return t[this.config.template] || PdpDefault;
		},
		isOpen() {
			return this.enabled && !!this.product;
		},
		enabled() {
			return this.config?.enabled;
		}
	},
	methods: {
		isProductValid(product) {
			const sku = getProductSku(product);
			const actionType = this.product?.actionType || this.product?.sku;
			return !!sku && actionType !== "url" && !product?.isVideo;
		},
		setProduct(product, blockData) {
			if (this.isProductValid(product)) {
				this.product = {
					...product,
					blockData: blockData || product.blockData
				};
			}
		},
		clearProduct() {
			this.product = null;
		},
		handleClickOutside(event) {
			if (this.$refs.clickableElement && !this.$refs.clickableElement.contains(event.target)) {
				this.clearProduct();
			}
		},
		onFeatureEvent(event, data) {
			if (this.enabled) {
				switch (event) {
					case PDP_EVENT_SHOW:
					case PRODUCT_REGION_CLICK_VALID:
						console.log("PDP Event Product Click:", data);
						if (this.config?.mode === PDP_MODE_INTERNAL) {
							this.setProduct(data?.product, data?.blockData);
						} else if (this.config?.mode === PDP_MODE_EXTERNAL) {
							console.log('External PDP click');
							Lytics.TransferToMerchantClick({
								page_number: this.currentPageNumber,
								data: {
									...data?.product || {},
									blockData: data?.blockData || {}
								}
							})
							//Use Configuration Events
							//ParentComms.SendData(ObjPropParser.Parse(this?.config?.post, {__self:{ product: data?.product, flyer:this.currentFlyer }}));
						}
						break;
					case PDP_EVENT_HIDE:
						this.clearProduct();
						break;
					case PRODUCT_REGION_CLICK_WITH_SKU:
						if (this.config?.forceInternal && data.sku) {
							this.setProduct(data?.product, data?.blockData);
						} else {
							// eslint-disable-next-line no-case-declarations
							const clickRegionWithUrl = data.product.clickRegions.find(clickRegion => clickRegion.url)
							if (clickRegionWithUrl) {
								window.open(clickRegionWithUrl.url)
							}
						}
						break;
					case PRODUCT_REGION_CLICK_EXTERNAL_LINK:
						if(this.config?.forceInternal && data.sku) {
							this.setProduct(data?.product, data?.blockData);
						}  else if (data.product.url !== '') {
							window.open(data.product.url)
						}
						break

				}
			}
		}
	}
};
</script>

<template>
	<div v-if="isOpen" class="pdp modal-wpr">
		<div
				ref="clickableElement"
				:class="`pdp-modal modal ${flyerOrientation} ${config.template || ''}`"
		>
			<component
					:is="pdpTemplate"
					:feature-config-path="featurePath"
					:product="product"
			/>
		</div>
		+
	</div>
</template>

<style lang="scss" scoped>
.pdp.modal-wpr {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 100;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  flex-flow: column;

  /* Center modal for v4 template */
  &:has(.pdp-modal.v4) {
    justify-content: center;
    align-items: center;

		.modal {
			margin: 0 20px;
			border-width: 0;
			max-width: 564px;
		}
  }

  .modal {
	background-color: var(--secondary-color);
	/*margin-top: 75px;*/
	border: 1px solid #bbbbbb;
	overflow-y: auto;
	overflow-x: hidden;
	max-height: calc(100% - 1em);
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
	display: flex;
	flex-flow: row;
	max-width: 370px;

	.header {
	  background-color: var(--secondary-color);
	  color: var(--primary-text-color);
	  display: flex;
	  justify-content: space-between;
	  padding: 10px;

	  h2 {
		font-size: 18px;
		text-transform: uppercase;
		font-weight: 400;
	  }

	  .close-btn {
		cursor: pointer;

		&:hover {
		  background: none;
		  filter: unset;
		}
	  }
	}

	.subtitle {
	  padding-top: 6px;
	  font-size: 12px;
	}

	.content {
	  padding: 8px;
	  background-color: #fff;
	  color: #545454;
	  position: relative;
	  flex: 1 0 auto;
	  overflow: auto;
	  // margin:0px 10px 10px 10px;
	  margin: 10px 10px 17px;
	  min-height: 250px;
	  max-height: calc(100% - 4em);
	  /*.scroll-container{
					position: absolute;
					top:0px;
					bottom:0px;
					left:0px;
					right:0px;
				}*/
	  .content-container {
		text-align: left;
		//width:300px;
	  }

	  .f-half {
		display: flex;
		column-gap: 1em;

		flex-direction: column;

		> div {
		  flex-basis: 100%;
		  display: flex;
		  flex-flow: column;
		}
	  }

	  .content-container {
		// width: 350px;
	  }

	  .feature {
		background: #eee;
		margin: 12px 0;
		display: flex;
		justify-content: center;
		flex: 1;

		.description {
		  display: flex;
		  font-size: 14px;
		  padding: 15px 0;

		  .button-preview {
			display: flex;
			flex-direction: column;
			align-items: center;
			padding: 0 20px;

			h4 {
			  text-transform: uppercase;
			  padding-top: 16px;
			  white-space: nowrap;
			}

			.subtitle {
			  text-align: center;
			}
		  }
		}
	  }
	}
  }
}
</style>
